import { ClientPlatformKind } from "@/domains/api/types";
import { clientEnvIsDesktop } from "@/modules/client-env/isDesktop";
import { clientEnvIsWindows } from "@/modules/client-env/isWindows";
import { clientEnvIsMacOs } from "@/modules/client-env/isMacOs";

export const clientEnvPlatformKind = (): ClientPlatformKind => {
  const isDesktop = clientEnvIsDesktop();

  if (isDesktop) {
    if (clientEnvIsWindows()) {
      return ClientPlatformKind.Windows;
    }
    if (clientEnvIsMacOs()) {
      return ClientPlatformKind.MacOS;
    }
    return ClientPlatformKind.Unknown;
  }

  return ClientPlatformKind.Web;
};
